(function(){
  function renderInstallmentsPanel(root) {
    if (!root || root.dataset.rendered === '1') return;
    var D = window.INSTALLMENTS_DATA;
    if (!D) return;
    var L = D.labels;
    function esc(s){return String(s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]})}
    function mark(p){return '<span class="ins-mark" style="background:'+p.color+';color:'+(p.ink||'#fff')+'">'+esc(p.mark)+'</span>'}
    function steps(s, calcHtml){
      return '<ol class="ins-steps">'+s.map(function(x,i){
        var isLast = i === s.length - 1;
        if (isLast && calcHtml) {
          return '<li><span class="ins-step-num">'+(i+1)+'</span><div class="ins-step-body"><span class="ins-step-text">'+esc(x)+'</span>'+calcHtml+'</div></li>';
        }
        return '<li><span class="ins-step-num">'+(i+1)+'</span>'+esc(x)+'</li>';
      }).join('')+'</ol>';
    }
    function kv(p){var r=[[L.kv[0],p.inst],[L.kv[1],p.rate],[L.kv[2],p.fee],[L.kv[3],p.min]];
      return '<div class="ins-kv">'+r.map(function(x){return '<div><em>'+esc(x[0])+'</em><b>'+esc(x[1])+'</b></div>'}).join('')+'</div>'}
    function fmtInstallment(item){
      return esc(item.numberOfMonths) + ' x ' + esc(item.installmentAmount) + ' €';
    }
    function calcHtml(prices){
      if (!prices || !prices.allPrices || !prices.allPrices.length) return '';
      var low = prices.lowestInstallmentAmount;
      var high = prices.highestInstallmentAmount;
      var first = prices.allPrices[0];
      if (!low || !high || !first) return '';
      return '<div class="ins-calc">' +
        '<div class="ins-calc-title">Enostavni obročni nakupi</div>' +
        '<div class="ins-calc-label">Želim čim nižji obrok</div>' +
        '<div class="ins-calc-info">' + fmtInstallment(low) + '</div>' +
        '<div class="ins-calc-label">Odplačati želim čim prej</div>' +
        '<div class="ins-calc-info">' + fmtInstallment(high) + '</div>' +
        '<div class="ins-calc-label">Želim si izbrati svoje obroke</div>' +
        '<div class="ins-calc-info" id="leanpay-panel-custom-amount">' + fmtInstallment(first) + '</div>' +
        '<input type="range" min="1" max="' + prices.allPrices.length + '" value="1" class="ins-calc-slider" id="leanpay-panel-range">' +
        '<p class="ins-calc-note">*0% obresti in stroškov v primeru nakupa do 300€ v spletni trgovini na 3 obroke ali do 500€ v fizični trgovini na 5 obrokov.</p>' +
        '<p class="ins-calc-note">Leanpay omogoča enostavne obročne nakupe preko spleta. Za obročno plačilo nakupa v košarici izberite Leanpay. Za nakup potrebujete vašo davčno številko in številko transakcijskega računa (SI56..)</p>' +
      '</div>';
    }
    var p=D.primary,html='';
    html+='<h1>'+esc(L.title)+'</h1>';
    html+='<div class="ins-hero"><div class="ins-hero-top">'+(p.logo?'<img src="'+p.logo+'" alt="'+esc(p.name)+'">':'<b class="ins-hero-name">'+esc(p.name)+'</b>')+(L.heroChip?'<span class="ins-chip">'+esc(L.heroChip)+'</span>':'')+'</div>';
    html+='<p class="ins-hero-claim">'+esc(p.claim)+'</p><div class="ins-hero-facts">'+p.facts.map(function(f){return '<div><em>'+esc(f[0])+'</em><b>'+esc(f[1])+'</b></div>'}).join('')+'</div>'+steps(p.steps, calcHtml(window.LEANPAY_INSTALLMENT_PRICES));
    html+='</div>';
    html+='<h2 class="ins-h">'+esc(L.secH)+'</h2><p class="ins-lead">'+esc(L.secLead)+'</p>';
    html+='<div class="ins-acc">'+D.cards.map(function(c){
      return '<div class="ins-acc-item" data-id="'+c.id+'"><button type="button" class="ins-acc-head">'+mark(c)+
      '<span class="ins-acc-name"><b>'+esc(c.name)+'</b><em>'+esc(c.card)+'</em></span><span class="ins-acc-inst">'+esc(c.inst)+'</span>'+
      '<svg class="ins-acc-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></button>'+
      '<div class="ins-acc-body"><div class="ins-acc-in">'+kv(c)+'<p class="ins-extra">'+esc(c.extra)+'</p>'+steps(c.steps)+'<span class="ins-link">'+esc(c.link)+'</span></div></div></div>';
    }).join('')+'</div>';
    html+='<div class="ins-table-wrap"><table class="ins-table"><thead><tr>'+L.th.map(function(h){return '<th>'+esc(h)+'</th>'}).join('')+'</tr></thead><tbody>'+
    D.cards.map(function(c){return '<tr><td><b>'+esc(c.bank||c.name)+'</b><em>'+esc(c.card)+'</em></td><td>'+esc(c.inst)+'</td><td>'+esc(c.fee)+'</td><td>'+esc(c.when)+'</td></tr>'}).join('')+'</tbody></table></div>';
    html+='<p class="ins-foot">'+esc(L.foot)+'</p>';
    root.innerHTML = html;
    root.dataset.rendered = '1';
    root.addEventListener('click',function(e){
      var h=e.target.closest('.ins-acc-head');
      if(!h) return;
      var it=h.parentElement,was=it.classList.contains('on');
      [].forEach.call(root.querySelectorAll('.ins-acc-item.on'),function(x){x.classList.remove('on')});
      if(!was) it.classList.add('on');
    });
    var slider = root.querySelector('#leanpay-panel-range');
    var customAmount = root.querySelector('#leanpay-panel-custom-amount');
    var prices = window.LEANPAY_INSTALLMENT_PRICES && window.LEANPAY_INSTALLMENT_PRICES.allPrices;
    if (slider && customAmount && prices) {
      slider.addEventListener('input', function() {
        var selectedPrice = prices[this.value - 1];
        if (!selectedPrice) return;
        customAmount.textContent = selectedPrice.numberOfMonths + ' x ' + selectedPrice.installmentAmount + ' €';
      });
    }
  }

  function initInstallmentsPanels() {
    document.querySelectorAll('.leanpay-installments-panel .ins-root').forEach(renderInstallmentsPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstallmentsPanels);
  } else {
    initInstallmentsPanels();
  }

  window.renderLeanpayInstallmentsPanel = renderInstallmentsPanel;
})();
